export default __webpack_public_path__ + "static/media/Destination3.2c626473.png";